export {default as request} from "./src/request";
export {default as html} from "./src/html";
export {default as json} from "./src/json";
export {default as text} from "./src/text";
export {default as xml} from "./src/xml";
export {default as csv} from "./src/csv";
export {default as tsv} from "./src/tsv";



//////////////////
// WEBPACK FOOTER
// ./~/d3-request/index.js
// module id = 843
// module chunks = 0